import {
    UPDATE_BANK_DETAILS_STATE    
} from '../Constants/actionTypes.constants';

export const initialStore = {
    completed: false,
};

export default (state = initialStore, action) => {
    switch (action.type) {
        case UPDATE_BANK_DETAILS_STATE:
            return {
                ...state,
                completed: true,
            };
        default:
            return state
    }
}
